import html2canvas from "html2canvas";


export const captureImage = (divElement, callback) => {
    //Create a canvas element
    setTimeout(() =>
            html2canvas(divElement)
                .then(canvas => {
                    const dataURL = canvas.toDataURL();
                    fetch(dataURL)
                        .then(res => res.blob())
                        .then(blob => {
                            // Gửi blob lên server
                            // Ví dụ: thay thế 'uploadUrl' bằng địa chỉ endpoint của server của bạn
                            callback(blob)
                        })
                        .catch(error => {
                            console.error('Error converting data URL to blob:', error);
                        });
                })
                .catch(function (error) {
                    console.error(
                        'oops, something went wrong!',
                        error
                    )
                })
        , 100
    )

};


